import React from "react";
import Heroicon from "../Heroicon";

function ImageMessage({ podcastCover }) {
  const {
    validDimensions,
    validRatio,
    validType,
    validSize,
    size,
    dimensions,
    validDimensionsMsg,
  } = podcastCover;
  return (
    <div>
      <p className="mt-4 mb-2 text-xs tracking-wider text-gray-400 uppercase border-b border-gray-200 border-dotted">
        Requirements
      </p>
      <ul className="mt-1 space-y-2 text-sm">
        <li className="grid grid-cols-[24px,1fr] item-start">
          {validRatio === null ? (
            <>
              <Heroicon
                icon="o-ellipsis-horizontal-circle"
                style="w-5 h-5 text-gray-300"
              />
              Image must be an exact square
            </>
          ) : validRatio ? (
            <>
              <Heroicon icon="o-check-circle" style="w-5 h-5 text-green-600" />
              Image is square
            </>
          ) : (
            <>
              <Heroicon icon="o-x-circle" style="w-5 h-5 text-red-600" />
              Image must be an exact square
            </>
          )}
        </li>
        <li className="grid grid-cols-[24px,1fr] item-start">
          {validDimensions === null ? (
            <>
              <Heroicon
                icon="o-ellipsis-horizontal-circle"
                style="w-5 h-5 text-gray-300"
              />
              Size between 1400 x 1400px and 3000 x 3000px
            </>
          ) : validDimensions ? (
            <>
              <Heroicon icon="o-check-circle" style="w-5 h-5 text-green-600" />
              Image size found: {dimensions}
            </>
          ) : (
            <>
              <Heroicon icon="o-x-circle" style="w-5 h-5 text-red-600" />
              Image size found: {dimensions} - {validDimensionsMsg}
            </>
          )}
        </li>
        <li className="grid grid-cols-[24px,1fr] item-start">
          {validType === null ? (
            <>
              <Heroicon
                icon="o-ellipsis-horizontal-circle"
                style="w-5 h-5 text-gray-300"
              />
              Type must be a PNG or JPG
            </>
          ) : validType ? (
            <>
              <Heroicon icon="o-check-circle" style="w-5 h-5 text-green-600" />
              Type is PNG or JPG
            </>
          ) : (
            <>
              <Heroicon icon="o-x-circle" style="w-5 h-5 text-red-600" />
              Type must be a PNG or JPG
            </>
          )}
        </li>
        <li className="grid grid-cols-[24px,1fr] item-start">
          {validSize === null ? (
            <>
              <Heroicon
                icon="o-ellipsis-horizontal-circle"
                style="w-5 h-5 text-gray-300"
              />
              Maximum file size of 1MB
            </>
          ) : validSize ? (
            <>
              <Heroicon icon="o-check-circle" style="w-5 h-5 text-green-600" />
              Image size found: {size}
            </>
          ) : (
            <>
              <Heroicon
                icon="o-exclamation-circle"
                style="w-5 h-5 text-yellow-600"
              />
              Image size found: {size}
            </>
          )}
        </li>
      </ul>
    </div>
  );
}

export default ImageMessage;
